import { apiClient } from './api/client';

export async function getPublicMembers() {
  return apiClient.get('/api/public/members', { skipAuth: true });
}

export async function getPublicEvents() {
  return apiClient.get('/api/public/events', { skipAuth: true });
}

export async function getPublicIndustriesSought(): Promise<string[]> {
  const data = await apiClient.get('/api/public/industries-sought', { skipAuth: true });
  const industries = data?.industries;
  return Array.isArray(industries) ? industries.map((x: any) => String(x)) : [];
}
